import { Toast } from '@base-ui/react/toast'

export interface NotifyOptions {
  description?: string
  id?: string | number
}

export const toastManager = Toast.createToastManager()

export const anchoredToastManager = Toast.createToastManager()

const show =
  (type: string) =>
  (message: string, options?: NotifyOptions): string =>
    toastManager.add({
      ...options,
      id: options?.id === undefined ? undefined : String(options.id),
      type,
      title: message,
    })

export const notify = {
  success: show('success'),
  error: show('error'),
  info: show('info'),
  // Toast PERSISTANT (pas d'auto-fermeture) : pour les traitements longs dont on remplace ensuite le toast par un
  // `success`/`error` portant le même `id`. Sans lui, un traitement d'une minute laisse l'écran muet.
  loading: show('loading'),
  warning: show('warning'),
}
